import { render, staticRenderFns } from "./itemTeachers.vue?vue&type=template&id=4c9312a7&scoped=true"
import script from "./itemTeachers.vue?vue&type=script&lang=ts"
export * from "./itemTeachers.vue?vue&type=script&lang=ts"
import style0 from "./itemTeachers.vue?vue&type=style&index=0&id=4c9312a7&prod&scoped=true&lang=css"
import style1 from "./itemDetails.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@/components/common/modern/modern.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9312a7",
  null
  
)

export default component.exports